import { FieldInputProps } from "formik";
import { NumericFormat, NumberFormatValues } from "react-number-format";

interface NumberCellProps extends FieldInputProps<any> {
  isPercentage?: boolean;
  hasError?: boolean;
}

const CustomInput = ({ isPercentage, value, name, onBlur, ...props }: any) => {
  const inputWidth = isPercentage ? "w-[5ch]" : "w-full";
  return (
    <div className="relative flex gap-0 group">
      <input
        {...props}
        name={name}
        value={value ?? 0}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onBlur(e as unknown as React.FocusEvent<HTMLInputElement>);
          }
        }}
        className={`block ${inputWidth} py-1 pl-2 bg-transparent outline-none group-focus-within:bg-gray-100 rounded-l-md ${
          props.hasError ? "placeholder-red-500" : ""
        }`}
        placeholder={props.hasError ? "*Required" : ""}
      />
      {isPercentage && value && (
        <span className="group-focus-within:bg-gray-100 py-1 rounded-r-md pr-2">
          %
        </span>
      )}
    </div>
  );
};

const NumberCell = ({
  isPercentage,
  name,
  value,
  onChange,
  onBlur,
  ...props
}: NumberCellProps) => {
  const handleValueChange = (values: NumberFormatValues) => {
    onChange({
      target: {
        name,
        value: values.floatValue,
      },
    });
  };

  return (
    <NumericFormat
      name={name}
      customInput={CustomInput}
      valueIsNumericString={true}
      thousandSeparator={true}
      value={value}
      decimalScale={2}
      fixedDecimalScale={false}
      onValueChange={handleValueChange}
      allowLeadingZeros={false}
      allowNegative={false}
      {...{ ...props, isPercentage: isPercentage }}
      onBlur={onBlur}
      isPercentage={isPercentage}
    />
  );
};

export default NumberCell;
